import { useEffect, useState } from "react";
import { ChatMessage, chatHistoryService } from "../services/chat.service";

export function useChatHistory(sessionId: string | null, apiKey?: string, embedOrigin?: string) {
    const [messages, setMessages] = useState<ChatMessage[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [sessionNotFound, setSessionNotFound] = useState(false);

    const fetchHistory = async () => {
        if (!sessionId) return;

        setIsLoading(true);
        setError(null);
        setSessionNotFound(false);

        try {
            const data = await chatHistoryService.getHistory(sessionId, apiKey, embedOrigin);
            setMessages(data);
        } catch (e: any) {
            const status = e?.response?.status;
            if (status === 404) {
                setSessionNotFound(true);
                setMessages([]);
            } else {
                setError(e?.message || "Erreur chargement historique");
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchHistory();
    }, [sessionId]);

    return {
        messages,
        isLoading,
        error,
        sessionNotFound,
        refetch: fetchHistory,
    };
}
